<!--我的账户-->
<template>
  <el-tabs v-model="activeName" type="card" class="tabs-one" style="padding-top: 20px;">
    <el-tab-pane name="1" class="active">
      <span slot="label"><i class="el-icon"></i>投资分享</span>
      <investmentSharing></investmentSharing>
    </el-tab-pane>
    <el-tab-pane name="2">
      <span slot="label"><i class="el-icon"></i>个人资料</span>
      <personalData></personalData>
    </el-tab-pane>
    <el-tab-pane name="3">
      <span slot="label"><i class="el-icon"></i>重置密码</span>
      <resetPassword v-if="activeName == '3'"></resetPassword>
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import investmentSharing from "./investmentSharing";
import personalData from "./personalData";
import resetPassword from "./resetPassword";
export default {
  components: {
    investmentSharing,
    personalData,
    resetPassword
  },
  data () {
    return {
      activeName: '1',
    }
  },
  created () {
    this.activeName = this.$route.params.active ? this.$route.params.active : '1'
  },
  methods: {

  }

}
</script>

<style lang="less" scoped>
</style>
